import { useRef } from 'react';
import useBuildVariantProps from '../../../modules/theme/useBuildVariantProps';
import { useControlledValue } from '../../molecules/FormField/useControlledValue';
import { mergeRefs } from '../../utils/utils';
import { InputProps } from './Input.types';

const inputTypeMap = {
  'Text': 'text',
  'Number': 'number',
  'Email': 'email',
  'Password': 'password',
} as const;

const usePresenter = (props: InputProps, ref: React.ForwardedRef<HTMLInputElement>) => {
  const {
    leadingIcon,
    trailingIcon,
    value,
    onValueChange,
    disabled = false,
    invalid = false,
    inputType = 'Text',
    required,
    preProcessInput,
    'component-variant': componentVariant,
    ...otherInputProps
  } = props;

  const internalInputRef = useRef<HTMLInputElement>(null);

  const { value: internalValue, onValueChange: handleValueChange } = useControlledValue({ value, onValueChange, defaultValue: '' }); 

  const onInputChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (preProcessInput && internalInputRef?.current) {
      internalInputRef.current.value = preProcessInput(event.target.value);
    }
    // updated value from change event object
    const updatedValue = internalInputRef.current?.value || '';
    handleValueChange(updatedValue);
  };

  const variantProps = useBuildVariantProps(
    'input',
    { inputType },
    {
      disabled,
      invalid,
    },
    componentVariant,
  );

  return {
    variantProps,
    onInputChanged,
    otherInputProps,
    leadingIcon,
    trailingIcon,
    value: internalValue,
    disabled,
    invalid,
    inputType: inputTypeMap[inputType],
    required,
    componentVariant,
    inputRef: mergeRefs(internalInputRef, ref),
  };
};

export default usePresenter;